import { h } from "preact";
import { useState } from "preact/hooks";


export default function AcheterViteUnBien() {

	return (<div>Le site est en maintenance</div>)
}